<template>
  <!-- 收货地址页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar title="收货地址" left-arrow @click-left="$router.back()" />
    </div>
    <div class="center">
      <van-address-list
        :switchable="false"
        v-model="chosenAddressId"
        :list="list"
        default-tag-text="默认地址"
        @add="onAdd"
        @edit="onEdit"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      chosenAddressId: "1",
    };
  },
  created() {
    this.getAddressList();
  },
  methods: {
    onAdd() {
      this.$router.push({ path: "/addToAddress" });
    },
    onEdit(item) {
      this.$router.push({ path: "/editAddress", query: { id: item.id } });
      // if (this.$route.path == "/editAddress") {
      //   this.$router.go(0);
      // } else {
      //   return false;
      // }
    },
    async getAddressList() {
      await this.$post({
        url: "/omsConsigneeAddress/findAll",
        method: "post",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            res.data.code.map((item) => {
              return this.list.push({
                id: item.address_id,
                name: item.consignee,
                tel: item.mobile.replace(item.mobile.substr(3, 4), "****"),
                address: item.address_str,
                isDefault: item.first_choice == 1 ? true : false,
              });
            });
            if (
              res.data.code.length == 0 &&
              sessionStorage.removeItem("_ADDRESS") != undefined
            ) {
              sessionStorage.removeItem("_ADDRESS");
            }
          }
        })
        .catch((err) => {
          this.$toast("加载失败");
        });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  min-height: 100%;
  position: relative;
  background: #e8e8e8;
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: #ffffff;
    .van-nav-bar {
      background-color: #40000000;
      /deep/.van-nav-bar__text {
        color: #000000;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          color: #030303;
          font-size: 0.533333rem;
          vertical-align: middle;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 600 !important;
      }
    }
  }
  .center {
    height: 100%;
    background-color: #1f000000;
    .van-address-list {
      padding-top: 1.5rem;
      .van-radio-group {
        padding-bottom: 1.5rem;
         /deep/.van-address-item__address{
        color: #999999;
      }
      }
    }
    .van-checkbox {
      background-color: #ffffff;
      border-radius: 0.21rem;
      margin-bottom: 0.27rem;
      /deep/.van-checkbox__icon.van-checkbox__icon--round {
        display: none;
      }
    }
    .van-card {
      width: 22.1875rem;
      height: 2.75rem;
      margin-top: 0.5rem;
      float: right;
      background-color: #ffffff;
      border-radius: 8%;
      .van-card__content {
        margin-left: 0.5rem;
        .van-tag.van-tag--plain.van-tag--default.van-hairline--surround {
          font-size: 0rem;
          .van-tag.van-tag--plain.van-tag--danger.van-hairline--surround {
            color: #ccc;
          }
        }
        .van-button {
          margin-left: 3.5rem;
          display: block;
          border-radius: 0.11rem;
        }
      }
      .van-tag {
        padding: 0.2em 0.3em;
      }
      .van-tag--default {
        background-color: #fff;
      }
      .van-tag.van-tag--default {
        color: #ccc;
      }
      .van-card__price {
        color: red;
      }
    }
  }
  .van-radio-group {
    margin-bottom: 1.5rem;
  }
}
</style>
